export default __webpack_public_path__ + "static/media/020-chocolate bar.d2afdec5.svg";